/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { FilledButton, Tooltip } from '@neo4j-ndl/react';

const Component = () => {
  const placements = [
    { label: 'Top', placement: 'top' as const },
    { label: 'Bottom', placement: 'bottom' as const },
    { label: 'Left', placement: 'left' as const },
    { label: 'Right', placement: 'right' as const },
    { label: 'Top Start', placement: 'top-start' as const },
    { label: 'Top End', placement: 'top-end' as const },
    { label: 'Bottom Start', placement: 'bottom-start' as const },
    { label: 'Bottom End', placement: 'bottom-end' as const },
  ];

  return (
    <div className="n-grid n-grid-cols-4 n-gap-token-16 n-p-token-16 n-place-items-center">
      {placements.map(({ placement, label }) => (
        <Tooltip key={placement} type="simple" placement={placement}>
          <Tooltip.Trigger hasButtonWrapper>
            <FilledButton size="small">{label}</FilledButton>
          </Tooltip.Trigger>
          <Tooltip.Content>Tooltip on {label.toLowerCase()}</Tooltip.Content>
        </Tooltip>
      ))}
    </div>
  );
};

export default Component;
